import ReqClient from './request.class'

// 创建广告组
export async function creatCampaign(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/campaign/create/',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      name: params.name,
      budget: params.budget,
      budget_mode: params.budget_mode,
      landing_type: params.landing_type,
      start_num: params.bitch_add_begin,
      end_num: params.bitch_add_end,
      req_id: params.req_id
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告组
export async function getCampaign(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/campaign/get/',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      id: params.id
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新广告组
export async function uploadCampaign(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/campaign/update/',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      id: params.id,
      name: params.name,
      budget: params.budget,
      budget_mode: params.budget_mode
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取定向人群包
export async function getCustomAudience(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/customAudience',
    method: 'POST',
    data: {
      select_type: 1,
      ad_account_id: params.account,
      page_id: params.pageIndex,
      page_size: params.pageSize
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 预估受众人群
export async function estimateAudience(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/estimateaudience',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询建议出价
export async function bidSuggest(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/bidsuggest/',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建广告计划
export async function createPlan(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/addcaohuaplan',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 建转化
export async function createPlan2(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/addtoutiaoplan',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告计划
export async function getPlan(params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/queryByAdIdAndMediaId',
    params: {
      ad_account_id: params.account,
      ad_id: params.id
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改广告计划
export async function updatePlan(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/ad/uptoutiaoplan',
    method: 'POST',
    data: params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 转化检查接口
export async function checkConvert(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/check',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      ch_platform_id: params.ch_platform_id,
      convert_source_type: params.convert_source_type,
      convert_check_url: params.convert_check_url,
      convert_type: params.convert_type
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询转化列表
export async function selectConvert(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/list',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      ch_platform_id: params.ch_platform_id,
      convert_source_type: params.convert_source_type,
      convert_check_url: params.convert_check_url
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 确定联调
export async function connectTest(params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/connectTest',
    params: {
      plan_id: params.id,
      device_no: params.device_no
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 检查计划存在创意
export async function checkCreative(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/creative/check',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建创意
export async function creatCreative(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/creative/create/',
    data: params,
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改创意
export async function uploadCreative(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/creative/update/',
    data: params,
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意
export async function getCreative(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/creative/get',
    data: params,
    method: 'POST'
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意词包
export async function getCreativeWordIds(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/creative_word/select',
    data: {
      ad_account_id: params.account
    },
    method: 'POST'
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 兴趣关键词ID转词
export async function id2word(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_tags/id2word',
    data: {
      ad_account_id: params.account,
      word_ids: params.wordIds
    },
    method: 'POST'
  })
  try {
    alert('兴趣关键词ID转词下线')
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
  }
}

// 兴趣关键词词转ID
export async function word2id(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_tags/word2id',
    data: {
      ad_account_id: params.account,
      words: params.words
    },
    method: 'POST'
  })
  try {
    alert('兴趣关键词词转ID下线')
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询兴趣词包
export async function getInterestTags(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_tags/select',
    params: {
      ad_account_id: params.account
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建兴趣词包
export async function creatInterestTags(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_tags/create',
    data: {
      ad_account_id: params.account,
      name: params.name,
      words: params.words
    },
    method: 'POST'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 行为类目查询（新版）
export async function getActionCategory(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/action/category',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 兴趣类目查询（新版）
export async function getInterestCategory(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/interest/category/',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取行为兴趣推荐关键词
export async function getKeywordSuggest(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool//interest_action/keyword/suggest/',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 行为关键词下拉查询
export async function getKeywordAction(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/action/keyword/',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 兴趣关键词下拉查询
export async function getKeywordInterest(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/interest/keyword/',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 行为类目下拉查询
export async function getCategoryAction(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/action/category/search',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 兴趣类目下拉查询
export async function getCagegoryInterest(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/interest/category/search',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 行为兴趣关键词ID转词（新版）
export async function actionId2Word(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/id2word/',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 批量验证行为动态词
export async function batchKeywordAction(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/action/batchKeywordAction',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 批量验证兴趣动态词
export async function batchKeywordInterest(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/interest_action/interest/batchKeywordInterest',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询外部计划
export async function queryOutPlanById(params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/queryOutPlanById',
    params: {
      ad_account_id: params.account,
      ad_id: params.id,
      media_id: params.media
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询推荐封面
export async function queryCoverVideo(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/video_cover/suggest',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      video_id: params.id
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询监测模板
export async function queryButlerList(params) {
  const Req = new ReqClient({
    url: '/api/ptom/monitor/template/page',
    method: 'POST',
    data: {
      keyWord: params.keyword,
      page_id: params.pageIndex,
      page_size: params.pageSize
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告主有效流量包
export async function getFlowPackage(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/union/flowPackageGet',
    method: 'POST',
    data: {
      ad_account_id: params.account
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取橙子建站地址
export async function siteGetList(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/union/siteGet',
    method: 'POST',
    data: {
      ad_account_id: params.account,
      page_id: params.pageIndex,
      page_size: params.pageSize,
      search: params.search
    }
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取自研落地页
export async function getAssetList(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/getAssetList',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 通过落地页链接查询详细信息
export async function queryExternalDetailByUrl(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/queryExternalDetailByUrl',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 获取商品详情
export async function getProductInfos(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getProductInfos',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取创意组件列表
export async function creativeCompList(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/creativeComponentList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 新建创意卡片
export async function addCreativeCard(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/creativeComponentCreate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改创意卡片
export async function UpdateCreativeCard(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/creativeComponentUpdate',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取试玩素材列表
export async function getPlayableList(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/playable_list/get',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

export async function getAppNameByMediaId(params) {
  const Req = new ReqClient({
    url: '/api/ptom/appinfo/getAppNameByMediaId',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询推广抖音号
export async function iesAccountSearch(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/iesAccountSearch',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取授权抖音达人视频
export async function getAuthedAwemeList(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/awemeAuthList',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据关联的星广联投任务id获取授权抖音达人视频
export async function getAuthedAwemeListByStarDeliveryTaskId(params) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/starDelivery/taskAuthorVideo/detail',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询优化目标
export async function getConvertListDeatil(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/adConvert/getConvertListDeatil',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询抖音类目列表
export async function getAwemeCategory(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/awemeMultiLevelCategory/get',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询抖音类目达人账号下拉联想
export async function awemeInfoSearch(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/awemeInfoSearch',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询抖音类目下的推荐达人
export async function getAwemeCategoryTopAuthor(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/awemeCategoryTopAuthor',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询抖音类似帐号
export async function getAwemeSimilarSearch(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/awemeSimilarAuthorSearch',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询抖音类似帐号
export async function getAwemeAuthorInfo(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/awemeAuthorInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询商品库列表
export async function getProductLibInfo(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getProductLibInfo',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 查询商品列表
export async function getProductInfoList(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getProductInfoList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
// 获取原生锚点
export async function nativeAnchorGet(data) {
  const Req = new ReqClient({
    url: '/api/ptom/promotion/nativeAnchorGet',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 头条搜索快投-获取搜索快投关键词
 * @param {*} data
 */
export async function getSearchKeywords(data) {
  const Req = new ReqClient({
    url: '/api/toutiao/tool/getSearchKeywords',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
